import angular from 'angular';
import $ from 'jquery';
import template from './revenueWidgetView.html';

function RevenueWidget(RevenueStatisticalService, RevenueFormatterService, REVENUE_PERIODS) {
    const ctrl = this;

    ctrl.$onInit = () => {
        const revenues = ctrl.revenues;
        const revenueSum = RevenueStatisticalService.getRevenueSum(ctrl.selectedPeriod.value, revenues);
        const revenuesByLast12Month = RevenueStatisticalService.getRevenuesByLast12Month(revenues);

        ctrl.initChart(revenuesByLast12Month);
        ctrl.setRevenueSum(revenueSum);
    };

    ctrl.setDefaultValues = () => {
        ctrl.chartContainerId = 'bar-chart-revenues';
        ctrl.periodOptions = [{
            value: REVENUE_PERIODS.LAST_12_MONTH,
            label: 'DASHBOARD_GRAPHS_DASHBOARD_LAST_12_MONTHS',
        }, {
            value: REVENUE_PERIODS.CURRENT_MONTH,
            label: 'DASHBOARD_GRAPHS_CURRENT_MONTH',
        }, {
            value: REVENUE_PERIODS.CURRENT_QUARTER,
            label: 'DASHBOARD_GRAPHS_CURRENT_QUARTER',
        }, {
            value: REVENUE_PERIODS.CURRENT_YEAR,
            label: 'DASHBOARD_GRAPHS_DASHBOARD_CURRENT_YEAR',
        }];
        ctrl.selectedPeriod = ctrl.periodOptions[0];
        ctrl.revenueSum = 0;
    };

    ctrl.initChart = (dataSource) => {
        const { currencyFormatter, dateFormatter } = RevenueFormatterService.getFormatters(dataSource);

        this.chart = $(`#${ctrl.chartContainerId}`).dxChart({
            dataSource,
            barWidth: 0.8,
            barDistance: 0.1,
            size: {
                height: 103,
                width: 180,
            },
            commonSeriesSettings: {
                argumentField: 'date',
                type: 'bar',
                point: {
                    visible: false,
                },
            },
            commonAxisSettings: {
                label: {
                    visible: false,
                },
                grid: {
                    visible: false,
                },
            },
            margin: {
                bottom: 20,
            },
            argumentAxis: {
                valueMarginsEnabled: false,
                discreteAxisDivisionMode: 'crossLabels',
                grid: {
                    visible: false,
                },
            },
            series: [{
                valueField: 'current',
                name: 'Actual Revenue',
                type: 'bar',
                color: '#4362A4',
            }],
            legend: {
                visible: false,
            },
            export: {
                enabled: false,
            },
            tooltip: {
                location: 'edge',
                enabled: true,
                font: {
                    family: 'Source Sans Pro, sans-serif',
                    size: 14,
                },
                customizeTooltip: dataItem => ({
                    text: `
                    ${dateFormatter.format(new Date(dataItem.argumentText))}<br/>
                    ${currencyFormatter.format(dataItem.valueText)}
               `,
                }),
            },
        }).dxChart('instance');
    };

    ctrl.setRevenueSum = (value) => {
        const revenues = ctrl.revenues;
        const { currencyFormatter } = RevenueFormatterService.getFormatters(revenues);

        ctrl.revenueSum = currencyFormatter.format(value);
    };

    ctrl.setSelectedPeriod = selectedPeriod => ctrl.selectedPeriod = selectedPeriod;

    ctrl.onPeriodSelect = (period) => {
        const revenues = ctrl.revenues;
        const revenueSum = RevenueStatisticalService.getRevenueSum(period.value, revenues);

        ctrl.setRevenueSum(revenueSum);
    };

    ctrl.setDefaultValues();
}

export const RevenueWidgetConfiguration = {
    template,
    controller: RevenueWidget,
    bindings: {
        revenues: '<',
    },
    controllerAs: 'revenueChartCtrl',
};

angular.module('TALENYA-FE').component('revenueWidget', RevenueWidgetConfiguration);
